import {
  PbWithdrawalRequestStatusEnum as Status,
  type PbWithdrawalRequest
} from '@itsrever/rever-api'

const STATUS_LABELS: Record<string, string> = {
  [Status.Received]: 'Received',
  [Status.AwaitingReturn]: 'Awaiting return',
  [Status.Returned]: 'Returned',
  [Status.Refunded]: 'Refunded',
  [Status.Closed]: 'Closed'
}

// The reference only lives here: it's what the shopper got, so merchants match the two by it.
const COLUMNS: [string, (w: PbWithdrawalRequest) => string][] = [
  ['Received (UTC)', (w) => w.received_at ?? ''],
  ['Reference', (w) => w.id ?? ''],
  ['Name', (w) => w.name ?? ''],
  ['Email', (w) => w.email ?? ''],
  ['Language', (w) => w.lang ?? ''],
  ['Order number', (w) => w.order_number ?? ''],
  ['Order ID', (w) => w.order_id ?? ''],
  ['Return process', (w) => w.process_id ?? ''],
  ['Status', (w) => STATUS_LABELS[w.status ?? ''] ?? ''],
  ['Refund by (UTC)', (w) => w.refund_by ?? ''],
  [
    'Withdrawal period ends, approx. (UTC)',
    (w) => w.withdrawal_period_ends_at ?? ''
  ],
  ['Closed (UTC)', (w) => w.closed_at ?? '']
]

export function withdrawalsCsv(rows: PbWithdrawalRequest[]): string {
  const lines = [
    COLUMNS.map(([header]) => header),
    ...rows.map((w) => COLUMNS.map(([, value]) => value(w)))
  ]
  return lines.map((cells) => cells.map(csvCell).join(',')).join('\r\n')
}

// Shoppers type these values, so a leading =, +, - or @ must not run as a spreadsheet formula.
function csvCell(value: string) {
  const safe = /^[=+\-@]/.test(value) ? `'${value}` : value
  return `"${safe.replace(/"/g, '""')}"`
}
